import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import WhatIs from "./components/WhatIs";
import CoordinatesHistoryConstellations from "./components/CoordinatesHistoryConstellations";
import DatesPersonalityTraits from "./components/DatesPersonalityTraits";
import SignsTheirElements from "./components/SignsTheirElements";
import WhatHousesInYourBirth from "./components/WhatHousesInYourBirth";
// import ZodiacList from "./components/ZodiacList";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "100%", height: "100%" }}>{children}</Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const WhatIsZodiac = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const tabs = [
    {
      code: "WhatIs",
      name: "What is the zodiac sign?",
      component: WhatIs,
    },
    // {
    //   code: "ZodiacList",
    //   name: "Zodiac List",
    //   component: ZodiacList,
    // },
    // {
    //   code: "CoordinatesHistoryConstellations",
    //   name: "Coordinates and history of constellations",
    //   component: CoordinatesHistoryConstellations,
    // },
    // {
    //   code: "DatesPersonalityTraits",
    //   name: "Dates and Personality Traits of Each Star Sign",
    //   component: DatesPersonalityTraits,
    // },
    {
      code: "SignsTheirElements",
      name: "The Zodiac Signs and Their Elements",
      component: SignsTheirElements,
    },
    {
      code: "WhatHousesInYourBirth",
      name: "What Houses In Your Birth Chart Mean",
      component: WhatHousesInYourBirth,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab
              label={tab.name}
              {...a11yProps(index)}
              sx={{
                textTransform: "unset",
                "&.Mui-selected": {
                  fontWeight: "bold",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel value={value} index={index}>
          {<tab.component />}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default WhatIsZodiac;
